<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.BatchChangeCompany')"
    width="600px"
    :close-on-click-modal="false"
  >

    <el-form label-width="80px" label-position="left" class="cargo-form">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.LoadingPort')">
            <cargo-advance-select
              no="loadingPortCode"
              filterable
              :select-type="selectTypeNames.basic_data_Airport"
              callback-method-type="value"
              :default-value="form.loadingPortCode"
              :callback-params="{key:'loadingPortCode'}"
              style="flex:1"
              @parentCallBack="obj=>{form.loadingPortCode=obj.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.PortOfDestination')">
            <cargo-advance-select
              no="destinationPortCode"
              filterable
              :select-type="selectTypeNames.basic_data_Airport"
              callback-method-type="value"
              :default-value="form.destinationPortCode"
              :callback-params="{key:'destinationPortCode'}"
              style="flex:1"
              @parentCallBack="obj=>{form.destinationPortCode=obj.value}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.SalesCompany')">
            <cargo-office-select
              no="salesOffice"
              :office-id="Number(form.salesOffice)"
              placeholder=" "
              @change="p=>{form.salesOffice=p.value;form.salesDepartment=0}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.OperationCompany')">
            <cargo-office-select
              no="opOffice"
              :office-id="Number(form.opOffice)"
              placeholder=" "
              @change="p=>{form.opOffice=p.value;form.opDepartment=0}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.SalesDepartment')">
            <cargo-department-new-select
              no="salesDepartment"
              placeholder=" "
              :enables="true"
              :sales-id="Number(form.sales)"
              :office-id="Number(form.salesOffice)"
              :department-id="Number(form.salesDepartment)"
              @change="p=>{departmentChargeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.OperationDepartment')">
            <cargo-department-select
              no="opDepartment"
              :enables="true"
              :office-id="Number(form.opOffice)"
              :department-id="Number(form.opDepartment)"
              placeholder=" "
              @change="p=>{form.opDepartment=p.value}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Sales')">
            <cargo-user-select
              no="sales"
              placeholder=" "
              :method-params="{category:'role',shape:'sales',active:true}"
              :default-value="form.sales||''"
              @change="p=>{salesChangeHandler(p);}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Operation')">
            <cargo-user-select
              no="op"
              :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
              :default-value="form.op||''"
              placeholder=" "
              @change="p=>{opChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerOffice')">
            <cargo-office-select
              no="csrOffice"
              :office-id="Number(form.csrOffice)"
              placeholder=" "
              @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.DocumentOffice')">
            <cargo-office-select
              no="dcOffice"
              :office-id="Number(form.dcOffice)"
              placeholder=" "
              @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('Message.Customer_Service')">
            <cargo-department-new-select
              no="csrDepartment"
              :enables="true"
              :sales-id="Number(form.sales)"
              :office-id="Number(form.csrOffice)"
              :department-id="Number(form.csrDepartment)"
              placeholder=" "
              @change="p=>{form.csrDepartment = p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('Message.Documentation_Department')">
            <cargo-department-select
              no="dcDepartment"
              :enables="true"
              :office-id="Number(form.dcOffice)"
              :department-id="Number(form.dcDepartment)"
              placeholder=" "
              @change="p=>{form.dcDepartment=p.value}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerService')">
            <cargo-user-select
              no="csr"
              :method-params="{category:'role',shape:'csr'}"
              :default-value="form.csr||''"
              placeholder=" "
              @change="p=>{csrChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Documents')">
            <cargo-user-select
              no="dc"
              :method-params="{category:'role',shape:'dc'}"
              :default-value="form.dc||''"
              placeholder=" "
              @change="p=>{useChangeHandler(p, 'dc', 'dc', 'dcDepartment', 'dcOffice')}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.SalesOfGoods')">
            <cargo-user-select
              no="cargoSalesId"
              :method-params="{category:'role',shape:'salesOfGoods'}"
              :default-value="form.cargoSalesId||''"
              placeholder=" "
              @change="p=>{useChangeHandler(p, 'salesOfGoods', 'cargoSalesId', 'cargoSalesDepartment', 'cargoSalesOffice')}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.AirlinePerson2')">
            <cargo-user-select
              no="planner"
              :method-params="{category:'role',shape:'airline'}"
              :default-value="form.planner||''"
              placeholder=" "
              @change="p=>{useChangeHandler(p, 'airline', 'planner', 'plannerDepartment')}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.FieldOperation')">
            <cargo-user-select
              no="siteOP"
              :method-params="{category:'role',shape:'siteOp'}"
              :default-value="form.siteOP||''"
              placeholder=" "
              @change="p=>{useChangeHandler(p, 'siteOp', 'siteOP', 'siteOpDepartment')}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
            <cargo-user-select
              ref="overseaOp"
              no="overseaOp"
              :default-value="form.overseaOp||''"
              :merge-load="true"
              placeholder=" "
              @change="p=>{useChangeHandler(p, 'overseaOp', 'overseaOp', 'overseaOpDepartment')}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="isAddUserDefinedRoles" :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')">
            <cargo-user-select
              no="userDefinedRoleId1"
              :method-params="{category:'role',shape:'userDefinedRole1'}"
              :default-value="form.userDefinedRoleId1||''"
              :merge-load="true"
              placeholder=" "
              @change="p=>{useChangeHandler(p, 'userDefinedRole1', 'userDefinedRoleId1', 'userDefinedRoleDept1', 'userDefinedRoleOffice1')}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole2')">
            <cargo-user-select
              no="userDefinedRoleId2"
              :method-params="{category:'role',shape:'userDefinedRole2'}"
              :default-value="form.userDefinedRoleId2||''"
              :merge-load="true"
              placeholder=" "
              @change="p=>{useChangeHandler(p, 'userDefinedRole2', 'userDefinedRoleId2', 'userDefinedRoleDept2', 'userDefinedRoleOffice2')}"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <p>{{ $t('SeaExport.NoteUseNumLast') }}</p>
    <div slot="footer">
      <el-button type="primary" no="ok" @click="btnConfirm">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import { batchModifyJobOffice } from '@/api/booking/job'
import { getLoading } from '@/utils/utilBaseElement'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect.vue'
import { User } from '@/class/model/sys/User'
import { cache, cacheName } from '@/utils/cacheManager'
import $store from '@/store'
import { Office } from '@/class/model/sys/Office'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'BatchModifyBranchDialog',
  components: { cargoDepartmentNewSelect, cargoDepartmentSelect, cargoOfficeSelect, cargoUserSelect, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    jobKeys: { type: Array, required: true }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      form: {
        jobKeys: [],
        loadingPortCode: '',
        destinationPortCode: '',
        op: 0,
        opDepartment: 0,
        opOffice: 0,
        sales: 0,
        salesDepartment: 0,
        salesOffice: 0,
        csr: 0,
        csrDepartment: 0,
        csrOffice: 0,
        dc: 0,
        dcDepartment: 0,
        dcOffice: 0,
        cargoSalesId: 0,
        cargoSalesDepartment: 0,
        cargoSalesOffice: 0,
        planner: 0,
        plannerDepartment: 0,
        siteOP: 0,
        siteOpDepartment: 0,
        overseaOp: 0,
        overseaOpDepartment: 0,
        userDefinedRoleId1: 0,
        userDefinedRoleDept1: 0,
        userDefinedRoleOffice1: 0,
        userDefinedRoleId2: 0,
        userDefinedRoleDept2: 0,
        userDefinedRoleOffice2: 0
      },
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      salesOfficeCheck: false, // 是否显示自定义岗位
      branchOfficeCheck: false // 分公司校验
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isAddUserDefinedRoles = Number(cache.config.get('IsAddUserDefinedRoles')) === 1
    this.salesOfficeCheck = Number(cache.config.get('SalesOfficeCheck')) === 1
    this.branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
  },
  methods: {
    async btnConfirm() {
      const loading = getLoading()
      // 调用接口保存
      this.form.jobKeys = this.jobKeys
      const resp = await batchModifyJobOffice(this.form).finally(() => loading.close())
      if (resp.ok && resp.data >= 0) {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        this.innerVisible = false
        this.$emit('reload')
      } else {
        this.$message.warning(this.$t('SeaExport.OperationFailed'))
      }
    },
    // 销售修改事件
    async salesChangeHandler(data) {
      const job = this.form
      job.sales = data.value
      job.salesOffice = 0
      job.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          job.salesOffice = data.defaultOfficeId
          job.salesDepartment = data.defaultDepId
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices && offices.length > 1) {
            for (const item of offices) {
              if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === $store.getters.currentOfficeId)) {
                job.salesOffice = item.officeId
                job.salesDepartment = item.departmentId
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            job.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              job.salesOffice = office.officeId
            }
          }
        }
      }
    },
    // 销售部门修改后，调整分公司信息
    async departmentChargeHandler(data) {
      const job = this.form
      job.salesDepartment = data.value
      if (job.salesDepartment > 0) {
        const office = await Office.getOfficeByUuid(data.officeUuid)
        if (office && job.salesOffice !== office.officeId) {
          job.salesOffice = office.officeId
        }
      }
    },
    // 操作
    async opChangeHandler(data) {
      const job = this.form
      job.op = data.value
      job.opDepartment = 0
      if (data.value) {
        const user = new User(data)
        if (user.defaultDepId && user.defaultOfficeId && user.defaultOfficeId === job.opOffice) {
          job.opDepartment = user.defaultDepId
        } else {
          if (job.opOffice > 0) {
            user.getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
              job.opDepartment = dep ? dep.departmentId : 0
            })
          } else {
            user.getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
              job.opDepartment = dep ? dep.departmentId : 0
            })
          }
        }
      }
    },
    // 客服修改事件
    async csrChangeHandler(data) {
      const job = this.form
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        if (data.defaultDepId && data.defaultOfficeId && job.opOffice === data.defaultOfficeId) {
          job.csrOffice = data.defaultOfficeId
          job.csrDepartment = data.defaultDepId
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
          if (offices && offices.length > 1) {
            for (const item of offices) {
              if (item.officeId === $store.getters.currentOfficeId) {
                const office = await Office.getOfficeById(item.officeId)
                job.csrOffice = office ? office.officeId : 0
                job.csrDepartment = item.departmentId
                break
              }
            }
          } else {
            const user = new User(data)
            const dep = await user.getDefaultDepartment('role', 'csr')
            if (dep) {
              job.csrDepartment = dep.departmentId
              const office = await Office.getOfficeByUuid(dep.officeUuid)
              job.csrOffice = office ? office.officeId : 0
            }
          }
        }
      }
    },
    // 切换用户转换对应部门或分公司
    async useChangeHandler(data, shape, fieldUser, fieldDept, fieldOffice = null) {
      await JobUtils.userChangeHandler(this.form, data, shape, fieldUser, fieldDept, fieldOffice)
    }
  }
}
</script>
